import { AuthenticationDetails, CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js"
import router from "@/router"
import store from "@/store"

var cognitoUser

export default {
  currentUserSession: function () {
    return new Promise((resolve, reject) => {
      var data = {
        UserPoolId: store.state.customisations.user_pool,
        ClientId: store.state.customisations.client_id
      }

      var userPool = new CognitoUserPool(data)
      var cognitoUser = userPool.getCurrentUser()

      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            // alert(err)
            reject(err)
          }
          resolve(session)
        })
      }
    })
  },
  changePassword: function (oldp, newp) {
    return new Promise((resolve, reject) => {
      var data = {
        UserPoolId: store.state.customisations.user_pool,
        ClientId: store.state.customisations.client_id
      }

      var userPool = new CognitoUserPool(data)
      var cognitoUser = userPool.getCurrentUser()

      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            reject(err)
          }
        })
      }

      cognitoUser.changePassword(oldp, newp, function (err, result) {
        if (err) reject(err)
        else resolve(result)
      })
    })
  },
  logIn: function (Username, Password) {
    return new Promise((resolve, reject) => {
      var authenticationData = {
        Username,
        Password
      }
      var authenticationDetails = new AuthenticationDetails(authenticationData)
      var poolData = {
        UserPoolId: store.state.customisations.user_pool,
        ClientId: store.state.customisations.client_id
      }
      var userPool = new CognitoUserPool(poolData)
      var userData = {
        Username,
        Pool: userPool
      }
      cognitoUser = new CognitoUser(userData)

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (response) => {
          onSuccess(response)
          resolve()
        },
        onFailure: (err) => {
          onFailure(err)
          reject()
        },
        newPasswordRequired: (response) => {
          store.commit("NEW_PASSWORD_REQUIRED", response)
          reject()
        }
      })
    })
  },
  logOut: function () {
    if (cognitoUser != null) {
      cognitoUser.signOut()
    }
    store.commit("user/SIGN_OUT")
    router.push({ name: "root" })
  },
  setNewPassword: function (newPassword) {
    // Handle required attributes here.

    let userAttributes = store.state.userAttributes
    delete userAttributes.email_verified
    delete userAttributes.email

    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: (response) => {
        store.dispatch({
          type: "setSuccess",
          message: "Password successfully changed"
        })

        onSuccess(response)
      },
      onFailure: onFailure
    })
  }
}

function onSuccess(result) {
  store.commit("schemas/CLEAR_SCHEMAS")

  store.dispatch("display/getLeftMenu").then(() => {
    var landing = store.state.display.leftMenu.filter((p) => p.landing)
    if (landing.length) router.push(landing[0].link)
    else router.push(store.state.display.leftMenu[0].link)
    store.commit("CLEAR_NEW_PASSWORD")
  })

  store.commit("user/SET_USER", result.idToken.payload)
}

function onFailure(err) {
  switch (err.code) {
    case "PasswordResetRequiredException":
      // return "new password required"
      resetPassword()
      break
    default:
      if (err.message) err.message = err.message.replace("PreAuthentication failed with error ", "")
      store.dispatch("setError", {
        message: err.message || JSON.stringify(err)
      })
  }
}

function resetPassword() {
  var verificationCode = prompt("Your password needs to be reset. Please input verification code: ", "")
  var newPassword = prompt("Enter new password: ", "")
  cognitoUser.confirmPassword(verificationCode, newPassword, {
    onSuccess: () => {
      alert("Password successfully reset")
    },
    onFailure: (err) => onFailure(err)
  })
}
